import React from "react";
import concat from "lodash/concat";
import isEqual from "lodash/isEqual";
import without from "lodash/without";
import i18n from "i18n";
import { FormControl, FormGroup, ListGroup, ListGroupItem } from "components/bootstrap";
import Icon from "components/common/Icon";
import OverlayTrigger from "components/common/OverlayTrigger";
import style from "./SelectPopover.css";
class SelectPopover extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelectionChange = (nextSelection) => {
      const { onItemSelect } = this.props;
      this.setState({ selectedItems: nextSelection });
      onItemSelect(nextSelection, () => this.overlay.hide());
    };
    this.clearItemSelection = () => {
      this.handleSelectionChange([]);
    };
    this.handleItemSelection = (item) => () => {
      const { multiple } = this.props;
      const { selectedItems } = this.state;
      let nextSelectedItems;
      if (multiple) {
        nextSelectedItems = selectedItems.includes(item) ? without(selectedItems, item) : concat(selectedItems, item);
      } else {
        nextSelectedItems = [item];
      }
      this.handleSelectionChange(nextSelectedItems);
    };
    this.filterData = (filterText, items) => {
      const newFilteredItems = items.filter((item) => item.match(new RegExp(filterText, "i")));
      this.setState({ filterText, filteredItems: newFilteredItems });
    };
    this.handleFilterChange = (items) => (event) => {
      const filterText = event.target.value.trim();
      this.filterData(filterText, items);
    };
    this.renderDataFilter = (items) => {
      const { filterPlaceholder } = this.props;
      const { filterText } = this.state;
      return /* @__PURE__ */ React.createElement(FormGroup, { controlId: "dataFilterInput", className: style.dataFilterInput }, /* @__PURE__ */ React.createElement(
        FormControl,
        {
          type: "text",
          placeholder: filterPlaceholder != null ? filterPlaceholder : i18n.t("select.type_to_filter", { ns: "common" }),
          value: filterText,
          onChange: this.handleFilterChange(items)
        }
      ));
    };
    this.renderClearSelectionItem = () => {
      const { clearSelectionText } = this.props;
      return /* @__PURE__ */ React.createElement(ListGroupItem, { onClick: this.clearItemSelection }, /* @__PURE__ */ React.createElement(Icon, { name: "close", className: "text-danger" }), " ", clearSelectionText != null ? clearSelectionText : i18n.t("actions.clear_selection", { ns: "common" }));
    };
    this.state = {
      filterText: "",
      filteredItems: props.items,
      selectedItems: props.selectedItems
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { items, selectedItems } = this.props;
    const { filterText } = this.state;
    if (!isEqual(selectedItems, nextProps.selectedItems)) {
      this.setState({ selectedItems: nextProps.selectedItems });
    }
    if (items !== nextProps.items) {
      this.filterData(filterText, nextProps.items);
    }
  }
  render() {
    const { displayDataFilter, itemFormatter, items, placement, triggerAction, triggerNode, disabled, title } = this.props;
    const { filteredItems, selectedItems } = this.state;
    const popover = /* @__PURE__ */ React.createElement(React.Fragment, null, displayDataFilter && this.renderDataFilter(items), selectedItems.length > 0 && this.renderClearSelectionItem(), /* @__PURE__ */ React.createElement("div", { className: style.scrollableList }, /* @__PURE__ */ React.createElement(ListGroup, null, filteredItems.map((item) => /* @__PURE__ */ React.createElement(
      ListGroupItem,
      {
        key: item,
        onClick: disabled ? () => {
        } : this.handleItemSelection(item),
        active: selectedItems.includes(item),
        disabled
      },
      itemFormatter(item)
    )))));
    return /* @__PURE__ */ React.createElement(
      OverlayTrigger,
      {
        ref: (c) => {
          this.overlay = c;
        },
        trigger: triggerAction,
        placement,
        overlay: popover,
        title,
        rootClose: true
      },
      triggerNode
    );
  }
}
SelectPopover.defaultProps = {
  filterPlaceholder: void 0,
  clearSelectionText: void 0,
  placement: "bottom",
  triggerAction: "click",
  items: [],
  itemFormatter: (item) => item,
  multiple: false,
  selectedItems: [],
  displayDataFilter: true,
  disabled: false
};
export default SelectPopover;
